export default function ImageStaggerGrid() {
  const images = [
    {
      id: 1,
      src: "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1200&q=80",
      alt: "AI and code visualization",
    },
    {
      id: 2,
      src: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?auto=format&fit=crop&w=1200&q=80",
      alt: "Developer working on software",
    },
    {
      id: 3,
      src: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1200&q=80",
      alt: "Team collaboration and brainstorming",
    },
    {
      id: 4,
      src: "https://images.unsplash.com/photo-1531297484001-80022131f5a1?auto=format&fit=crop&w=1200&q=80",
      alt: "Modern workspace with laptop",
    },
    {
      id: 5,
      src: "https://images.unsplash.com/photo-1504639725590-34d0984388bd?auto=format&fit=crop&w=1200&q=80",
      alt: "AI data visualization",
    },
    
  ];

  return (
    <section className="py-5 bg-dark text-light">
      <div className="container">
        {/* Header */}
        <div className="text-center mb-5">
          <h2 className="fw-bold">Inside Our Platform</h2>
          <p className="text-light opacity-75 mt-2">
            A glimpse into our learning environment, technology, and community.
          </p>
        </div>

        {/* Staggered Grid */}
        <div className="stagger-grid">
          {images.map((img) => (
            <div key={img.id} className="stagger-item">
              <img
                src={img.src}
                alt={img.alt}
                loading="lazy"
                className="img-fluid"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
